import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './pages/register/register';
import Login from './pages/signin/signin';
import Home from './components/home/home';
import SerialNumberInput from './pages/serialNumberInput/serialNumberInput';
import EmailVerification from './pages/emailVerification/emailVerification';
import Dashboard from './pages/customerDashboard/dashboard';
import CallLogs from './pages/customerDashboard/callLogs';
import DestinationHistory from './pages/customerDashboard/destinationHistory';
import MyDevices from './pages/customerDashboard/myDevices';
import UserProfileEditor from './pages/editProfile/editProfile';
import CustomerDetail from './pages/customerDetail/customerDetail';
import AdminDashboard from './pages/adminDashboard/adminDashboard';
import StartupMessage from './pages/startupMessage/startupMessage';
import SubscriptionPlans from './pages/subscriptionPlans/subscriptionPlans';
import ContactMain from './pages/contactsPage/contactMain';
import SettingsPage from './pages/settingsPage/settingsPage';
import TextMessages from './pages/TextMessages/textMessages';
import Messages from './pages/messages/messages';
import Milestones from './pages/milestones/milestone';
import CallPage from './pages/callPage/callPage';
import SharedCallPage from './pages/callPage/sharedCallPage';
import FaceRecognition from './pages/faceRecognition/faceRecognition';
import EmailInbox from './pages/emailInbox/emailInbox';
import GoogleCallback from './pages/emailInbox/googleCallback';
import OutlookCallback from './pages/emailInbox/outlookCallback';
import TicketList from './pages/tickets/ticketList';
import TicketDetail from './pages/tickets/ticketDetail';
import CreateTicket from './pages/tickets/createTicket';
import EditTicket from './pages/tickets/editTicket';
import DeviceManagement from './pages/deviceManagement/deviceManagement';
import CaseManagement from './pages/caseManagement/caseManagement';
import OtaService from './pages/otaService/otaService';
import HelpdeskPage from './pages/helpdeskPage/helpdeskPage';
// TEMPORARY -- AI interaction log export, added 2026-08-06. See
// REMOVE_ai_interaction_export.md at the repo root.
import AiExport from './pages/aiExport/aiExport';

import ResetPasswordForm from './pages/forgotPassword/resetPassword';
import ForgotPasswordForm from './pages/forgotPassword/forgotPassword';

import 'leaflet/dist/leaflet.css';

import { SipProvider } from './pages/callPage/sipContext';
import IncomingCallPopup from './components/alerts/incomingCallPopup';

import ProtectedRoute from './pages/signin/protectedRoute';
import DashboardLayout from './components/dashboardLayout/dashboardLayout';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('jwt_token'));

  return (
    <SipProvider>
      <Router>
        <IncomingCallPopup />
        <Routes>
          {/* Public routes */}
          <Route path="/signup/:device_key" element={<Register />} />
          <Route path="/signup/:device_key/:case_key" element={<Register />} />
          <Route path="/signin" element={<Login setToken={setToken} />} />
          <Route path="/" element={<Login setToken={setToken}/>} />
          <Route path="/validate" element={<SerialNumberInput />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />

          {/* Shared call page - public, no authentication required */}
          <Route path="/shared-call/:contactid" element={<SharedCallPage />} />

          {/* Customer detail - standalone page */}
          <Route path="/customer/:id" element={<CustomerDetail/>} />
          
          {/* Protected Dashboard Routes with new DashboardLayout (Sidebar + TopBar) */}
          <Route
            path="/user-dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* All dashboard pages - these render inside DashboardLayout */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="admin-dashboard" element={<AdminDashboard />} />
            <Route path="startup-message" element={<StartupMessage />} />
            <Route path="my-devices" element={<MyDevices />} />
            <Route path="destination-history" element={<DestinationHistory />} />
            <Route path="call-logs" element={<CallLogs />} />
            <Route path="face-recognition" element={<FaceRecognition />} />
            <Route path="edit-profile" element={<UserProfileEditor />} />
            <Route path="my-subscription" element={<SubscriptionPlans />} />
            <Route path="my-contacts" element={<ContactMain />} />
            <Route path="chat" element={<TextMessages />} />
            <Route path="messages" element={<Messages />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="milestones" element={<Milestones />} />
            <Route path="call" element={<CallPage />} />
            <Route path="email-inbox" element={<EmailInbox />} />
            <Route path="google/callback" element={<GoogleCallback />} />
            <Route path="outlook/callback" element={<OutlookCallback />} />

            {/* Ticket routes */}
            <Route path="tickets" element={<TicketList />} />
            <Route path="tickets/create" element={<CreateTicket />} />
            <Route path="tickets/:id" element={<TicketDetail />} />
            <Route path="tickets/:id/edit" element={<EditTicket />} />

            {/* Device Management route */}
            <Route path="device-management" element={<DeviceManagement />} />

            {/* Case Management route */}
            <Route path="case-management" element={<CaseManagement />} />

            {/* OTA Service and Helpdesk -- embedded (iframe) tabs, single
                sign-on via a one-time code minted by /api/sso/issue-code/ */}
            <Route path="ota-service" element={<OtaService />} />
            <Route path="helpdesk" element={<HelpdeskPage />} />

            {/* TEMPORARY -- AI interaction log export, added 2026-08-06.
                See REMOVE_ai_interaction_export.md at the repo root. */}
            <Route path="ai-export" element={<AiExport />} />
          </Route>
        </Routes>
      </Router>
    </SipProvider>
  );
};

export default App;